<form>
	<!-- Modal Header -->
	<div class="modal-header">
		<h4 class="modal-title">Update Company</h4>
		<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
	</div>

	<div class="modal-body">
		<div class="container-fluid p-2">
			<div class="d-grid gap-3">
				<div class="form-floating">
					<input type="text" required class="form-control" [(ngModel)]="company.CompanyCode" name="companyCode" placeholder="Company Code" />
					<label for="companyCode" class="form-label">Company Code</label>
				</div>
				<div class="form-floating">
					<input type="text" required class="form-control" [(ngModel)]="sqlInfo.GLCode" name="glCode" placeholder="SQL GLCODE" />
					<label for="sqlCode" class="form-label">SQL GL CODE</label>
				</div>
				<mat-form-field subscriptSizing="dynamic">
					<mat-label>Date Operating</mat-label>
					<input matInput [matDatepicker]="dateOperating" name="dateOperating" [(ngModel)]="company.DateOperating" required />
					<mat-datepicker-toggle matSuffix [for]="dateOperating"></mat-datepicker-toggle>
					<mat-datepicker #dateOperating name="date"></mat-datepicker>
				</mat-form-field>
				<app-select-business-license [(businessId)]="businessId" [(branchId)]="branchId" [displayBranchOnly]="false"></app-select-business-license>
			</div>
		</div>
	</div>

	<div class="modal-footer">
		<button class="btn btn-outline-success" type="button" (click)="submit()">Update Company</button>
		<button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
	</div>
</form>
